import {
  Timeline,
  TimelineItem,
  TimelineConnector,
  TimelineHeader,
  TimelineIcon,
  TimelineBody,
  Typography,
  Avatar,
} from "@material-tailwind/react";
import { ibm, targetGrid, tcs } from "../../assets";

const ExperienceList = () => {
  const eduList = [
    {
      name: "System Engineer",
      company: "Tata Consultancy Services",
      techStack: "Not Assign till now",
      icon: tcs,
      project: "Not Assign till now",
      time: "[12/07/2024 - Present]",
    },
    {
      name: "Fullstack Developemnt Intern",
      company: "TargetGrid.co",
      techStack: "Reactjs, TypeScript, TailwindCSS, NodeJS, MongoDB.",
      icon: targetGrid,
      project: "Chrome extension, Viewer Library, Sales service platform.",
      time: "[01/02/2024 - 31/07/2024]",
    },
    {
      name: "Frontend Development Intern",
      company: "IBM SkillBild",
      techStack: "HTML5, TailwindCSS, Reactjs",
      icon: ibm,
      project: "Portfolio Website",
      time: "[21/12/2022 - 22/02/2023]",
    },
    // {
    //   name: "MERN Stack Industrial Training",
    //   company: "Ardent Computech Pvt. Ltd.",
    //   techStack: "Reactjs, TailwindCSS, NodeJS, ExpressJS, MongoDB.",
    //   icon: ardent,
    //   project: "E-Commerce Website",
    //   time: "[05/07/2022 - 04/08/2022]",
    // },
  ];

  return (
    <div className="max-w-[34rem] flex justify-center items-center mx-auto">
      <Timeline>
        {eduList.map((exp) => (
          <TimelineItem key={exp.level}>
            <TimelineConnector />
            <TimelineHeader>
              <TimelineIcon className="p-0">
                <Avatar size="md" src={exp.icon} alt={exp.level} />
              </TimelineIcon>
              <Typography>
                <div className="flex flex-row gap-1 items-center justify-start">
                  <h3 className="text-lg text-slate-950 font-semibold">
                    {" "}
                    {exp.name}
                  </h3> 
                  <h5 className="text-xs text-slate-800 font-medium">
                    {exp.time}
                  </h5>
                </div>
              </Typography>
            </TimelineHeader>
            <TimelineBody className="pb-12">
              <Typography>
                <div className="flex flex-col gap-1 items-start justify-start w-full h-full">
                  <div className="flex flex-row gap-2 items-start justify-start w-full h-full">
                    <h2 className="text-sm text-slate-950 font-semibold min-w-[100px] max-w-full">
                    Company :{" "}
                    </h2>
                    <h4 className="text-sm text-slate-950 font-semibold w-full">
                      {" "}
                      {exp.company}  
                    
                    </h4>
                  </div>
                  <div className="flex flex-row gap-2 items-start justify-start w-full h-full">
                    <h2 className="text-sm text-slate-950 font-semibold min-w-[100px] max-w-full">
                    Tech Stack :{" "}
                    </h2>
                    <h4 className="text-sm text-slate-950 font-medium w-full">
                      {" "}
                      {exp.techStack}
                    </h4>
                  </div>

                  <div className="flex flex-row gap-2 items-start justify-start w-full h-full">
                    <h2 className="text-sm text-slate-950 font-semibold min-w-[100px] max-w-full">
                      Project :{" "}
                    </h2>
                    <h4 className="text-sm text-slate-950 font-medium w-full">
                      {" "}
                      {exp.project}
                    </h4>
                  </div>
                </div>
              </Typography>
            </TimelineBody>
          </TimelineItem>
        ))}
      </Timeline>
    </div>
  );
};

export default ExperienceList;
